import SingleDatePicker from '../Pickers/SingleDatePicker';
import RangePicker from '../Pickers/RangePicker';

export const SingleDatePickerComponent = SingleDatePicker;
export const RangePickerComponent = RangePicker;

const DatePickerComponent = {
    SingleDatePicker: SingleDatePickerComponent,
    RangePicker: RangePickerComponent
};

export default DatePickerComponent; 